import { MAX_SOURCE_IMAGE_BYTES, MAX_UPLOAD_IMAGE_BYTES, optimizeImageForUpload } from './luggageImageOptimizer'

export async function prepareLuggagePhoto (file) {
  if (!/^image\//i.test(file.type) && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name)) {
    throw new Error('This file cannot be uploaded. Please select a photo.')
  }
  if (file.size > MAX_SOURCE_IMAGE_BYTES) throw new Error('Please select a photo smaller than 25 MB.')
  const result = await optimizeImageForUpload(file, 'luggage')
  if (result.file.size > MAX_UPLOAD_IMAGE_BYTES) {
    throw new Error('Photo could not be reduced below 10 MB. Please select a smaller JPEG image.')
  }
  const canPreview = !result.fallbackReason &&
    /^image\//i.test(result.file.type) &&
    !/image\/hei(c|f)/i.test(result.file.type) &&
    !/\.(heic|heif)$/i.test(result.file.name)
  return { file: result.file, canPreview }
}
